const Icon = () => (
  <path d="M776.061 948.090c17.689 16.571 18.59 44.348 2.019 62.031-15.068 16.080-39.386 18.285-56.976 6.103l-5.055-4.084-468.115-438.635c-16.101-15.084-18.289-39.451-6.059-57.034l4.102-5.062 468.113-497.594c16.612-17.653 44.384-18.501 62.037-1.894 16.050 15.097 18.21 39.423 5.992 56.986l-4.096 5.050-437.938 465.545 435.979 408.589z" />
)

export default Icon
